import { render } from "./DownloadStatisticView.vue?vue&type=template&id=2e3c8fb2&scoped=true"
import script from "./DownloadStatisticView.vue?vue&type=script&lang=js"
export * from "./DownloadStatisticView.vue?vue&type=script&lang=js"

import "./DownloadStatisticView.vue?vue&type=style&index=0&id=2e3c8fb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3c8fb2"]])

export default __exports__